import { Directive, ElementRef, HostListener } from '@angular/core';

const DISABLE_TIME = 600;
@Directive({
    selector: '[preventDoubleclick]',
})
export class PreventDoubleclickDirective {
    constructor(private elementRef: ElementRef) {}
    @HostListener('click', ['$event'])
    clickEvent() {
        this.elementRef.nativeElement.setAttribute('disabled', 'true');
        setTimeout(() => this.elementRef.nativeElement.removeAttribute('disabled'), DISABLE_TIME);
    }
}